import { VideoPlayer } from '../../../components/video-player/video-player'

import CSS from './video-grid.module.css'

export const VideoGrid = ({ children, videoUrl, decal = 'bg-dark' }) => {
    return (
        <section className={CSS.layout}>

            <section className={`${CSS.videoContainer} ${decal}`}>
                <div className="container">
                    <VideoPlayer videoUrl={videoUrl} />
                </div>
            </section>

            <section className={`block ${decal}`}>
                <div className="container">
                    { children }
                </div>
            </section>

        </section>
    )
}